// extracted by mini-css-extract-plugin
export default {"base":"HomeTorneosInt_base__mnI2b","contenedorCuadros":"HomeTorneosInt_contenedorCuadros__uTUUi"};